(function (jQuery) {
  function animateCounter(counter) {
    const target = +counter.data("target");
    const increment = target / 150;
    let count = 0;

    function updateCounter() {
      count += increment;
      if (count < target) {
        counter.text(`${Math.ceil(count).toLocaleString()}+`);
        requestAnimationFrame(updateCounter);
      } else {
        counter.text(`${target.toLocaleString()}+`);
      }
    }

    updateCounter();
  }

  const counter = $(".customer-counter");

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        animateCounter(counter);
        observer.unobserve(entry.target);
      }
    });
  }, {threshold: 1});

  observer.observe(counter[0]);
})();
